<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                list: [
                    {
                        title: 'Карточка',
                        url: `/pharmacies/${this.$route.params.id}/drugs/${this.$route.params.drug_id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/pharmacies/${this.$route.params.id}/drugs/${this.$route.params.drug_id}/edit`,
                    },
                    {
                        title: 'Категории',
                        url: `/pharmacies/${this.$route.params.id}/drugs/${this.$route.params.drug_id}/categories`,
                    },
                ],
            };
        },
    };
</script>
